/*
 * Module for the System portal messages page
 */
rs.module("content/system_/activity/messagecenterthreads/index",

    ["controls/data/grid", "ui/framework/client-templates"],

    function (gridModule, clientTemplates) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls, aiEnabled, clientTemplateKeys) {

            var filterForm = $.js(jsSelectors.filterForm);
            var includeClosed = filterForm.js(jsSelectors.includeClosed);

            if (aiEnabled) {

                $.js(jsSelectors.portalMessages).onjs("click", jsSelectors.summarizeButton, function (event) {
                    var currentButton = $(this);

                    var existing = $(this).data('summary');
                    if (existing) {
                        // return without summarizing anything.
                        // popover is already initialized, so it will just appear with the existing summary.
                        return;
                    }

                    currentButton.togglePulse(true);
                    showSummaryPopup(currentButton, clientTemplates.render(clientTemplateKeys.summaryLoading));

                    $.get(
                        backendUrls.getMessageThreadSummary,
                        {
                            contactLogCrmFolderKey: currentButton.data("route-contactlogcrmfolderkey")
                        }
                    )
                    .done(function (result) {
                        var aiSummary = result.summary;
                        currentButton.data('summary', aiSummary);
                        showSummaryPopup(currentButton, clientTemplates.render(clientTemplateKeys.summary, { "summary": aiSummary }));
                        
                    })
                    .fail(function (hxr, status, error) {
                        showSummaryPopup(currentButton, clientTemplates.render(clientTemplateKeys.summaryError));
                    })
                    .always(function () {
                        currentButton.togglePulse(false);
                    });
                });

                // Shows the AI summary
                function showSummaryPopup(element, summary) {
                    // dispose it so we can change the content
                    $(element).popover('dispose');

                    // show it
                    $(element).popover({
                        customClass: 'system__thread-summary-ai-popover',
                        placement: 'right',
                        content: summary,
                        html: true,
                        title: "AI Summary",
                        trigger: "focus"
                    });
                    $(element).popover('show');
                }
            }

            includeClosed.on("change", function () {
                filterForm.js(jsSelectors.loadingSpinner).show();

                gridModule.update(
                    backendUrls.getGridData,
                    {
                        includeClosedFlag: includeClosed[0].checked
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        filterForm.js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });            
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);